import { isDevelopmentEnvironment } from "@/lib/env";

// Desligado: a tela "Retornos do ERP" não aparece. Ligue (true) junto com a flag do backend (InvoiceIntegrationFeature).
export const INVOICE_RETURNS_ENABLED = true;

// Ligado: a tela só aparece fora de produção (localhost e homologação/DEV), usando a mesma verificação de ambiente do
// resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const INVOICE_RETURNS_DEV_ONLY = true;

export let isInvoiceReturnsEnabled = false;

// Tela "Retornos do ERP" (Administrativo): acompanhamento das notas fiscais e dos status de OV que o ERP enviou ao portal
// (POST /api/invoices e POST /api/invoices/sales-order-status). Comente a linha abaixo para desativar no frontend.
// Mantenha em sincronia com Features/InvoiceIntegrationFeature.cs do backend.
isInvoiceReturnsEnabled = INVOICE_RETURNS_ENABLED && (!INVOICE_RETURNS_DEV_ONLY || isDevelopmentEnvironment);
